import api from '..'
import { ICourseCard } from '../../models/courseCard.model'
import { IEnrolCard } from '../../models/enrolCard.model'

export interface Folder {
  id: string
  type: string
  attributes: IResumeFolder
}
export interface IResumeFolder {
  id: number
  name: string
  show: boolean
  order: number
  createdAt: Date
  sortSettings: SortSettings
  totalCourses: number
  courses: Courses
  coursesCount?: number
}
export interface Courses {
  data: Datum[]
}

export interface Datum {
  id: string
  type: 'card_course'
  attributes: {
    course: ICourseCard
    enrol: IEnrolCard
  }
}

export interface SortSettings {
  fields?: SortField[]
}

export interface SortField {
  attribute: string
  direction?: null | string
}

const resumeFolders = ({ page = 1, perPage = 8, search = '' }) => {
  return api
    .get<{ data: Folder[] }>('/courses/resume_folders', {
      params: {
        page,
        per_page: perPage,
        search,
      },
    })
    .then(({ data }) =>
      data.data.map(({ attributes }) => ({
        ...attributes,
        courses: attributes.courses.data.map((course) => course.attributes),
      }))
    )
}

export default resumeFolders
